import { SHOW_MODAL, HIDE_MODAL, UPDATE_WHEEL, PORTAL_UPDATE_CATEGORY_MORE, PORTAL_UPDATE_COUPON_MORE } from '../constants/ActionTypes';
import fetch from 'isomorphic-fetch';
import { camelizeKeys } from 'humps';
import queryString from 'query-string';
import { fetchWithJson } from '../utils/api';

import { 
  FETCH_PROFILE_REQUEST, FETCH_PROFILE_SUCCESS, FETCH_PROFILE_ERROR, 
  FETCH_POST_REQUEST, FETCH_POST_SUCCESS, FETCH_POST_ERROR, 
  FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS, FETCH_POSTS_ERROR, 
  FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_ERROR, 
  REQUEST_CHAT_REQUEST, REQUEST_CHAT_SUCCESS, REQUEST_CHAT_ERROR,
  TOGGLE_DIRECTION_AND_EMPTY_ITEMS 
} from '../constants/ActionTypes';

import {
  PORTAL_FETCH_CATEGORIES_REQUEST, PORTAL_FETCH_CATEGORIES_SUCCESS, PORTAL_FETCH_CATEGORIES_ERROR,
  PORTAL_FETCH_EVENTS_REQUEST, PORTAL_FETCH_EVENTS_SUCCESS, PORTAL_FETCH_EVENTS_ERROR,
  PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_REQUEST, PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS, PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_ERROR,
  PORTAL_FETCH_PROFILES_RISE_REQUEST, PORTAL_FETCH_PROFILES_RISE_SUCCESS, PORTAL_FETCH_PROFILES_RISE_ERROR,
  PORTAL_SCROLL_PROFILES_RISE_REQUEST, PORTAL_SCROLL_PROFILES_RISE_SUCCESS,
  PORTAL_FETCH_COUPON_RECEIVED_REQUEST, PORTAL_FETCH_COUPON_RECEIVED_SUCCESS, PORTAL_FETCH_COUPON_RECEIVED_ERROR,
  PORTAL_FETCH_COUPON_RECOMMEND_REQUEST, PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS, PORTAL_FETCH_COUPON_RECOMMEND_ERROR,
  PORTAL_RECEIVE_COUPON, PORTAL_ADD_FRIEND, PORTAL_BLOCK_FRIEND
} from '../constants/ActionTypes';

import {
  FETCH_MEMBERSHIP_REQUEST, FETCH_MEMBERSHIP_SUCCESS, FETCH_MEMBERSHIP_ERROR
} from '../constants/ActionTypes';

const NO_CONTENT = 204;

export function requestChat(profileId) {
  const url = `/api/profiles/${profileId}/chat_requests`;
  return function (dispatch) {
    dispatch(requestChatRequest(profileId));
    return fetch(url, { method: 'POST' })
      .then(res => res.json())
      .then(json => dispatch(requestChatSuccess(camelizeKeys(json))))
      .catch(response => dispatch(requestChatError(response)));
  };
}

function requestChatRequest(profileId) {
  return {
    type: 'REQUEST_CHAT_REQUEST'
  };
}

function requestChatSuccess(result) {
  return {
    type: 'REQUEST_CHAT_SUCCESS',
    result
  };
}

function requestChatError(response) {
  return {
    type: 'REQUEST_CHAT_ERROR',
    response
  };
}

export function fetchProfile(profileId, opts = {}) {
  const url = `/api/profiles/${profileId}?${queryString.stringify(opts)}`;
  return function (dispatch) {
    dispatch(fetchProfileRequest(profileId, opts));
    return fetch(url)
      .then(res => res.json())
      .then(json => dispatch(fetchProfileSuccess(camelizeKeys(json))))
      .catch(response => dispatch(fetchProfileError(response)));
  };
}

export function fetchProfileRequest(profileId, opts = {}) {
  return {
    type: FETCH_PROFILE_REQUEST,
    profileId,
    opts
  };
}

export function fetchProfileSuccess(result) {
  return {
    type: FETCH_PROFILE_SUCCESS,
    result
  };
}
export function fetchProfileError(response) {
  return {
    type: FETCH_PROFILE_ERROR
  };
}

export function fetchPosts(profileId, opts = {}) {
  const url = `/api/profiles/${profileId}/posts?${queryString.stringify(opts)}`;
  return function (dispatch) {
    dispatch(fetchPostsRequest(profileId, opts));
    return fetch(url)
      .then(res => res.json())
      .then(json => dispatch(fetchPostsSuccess(camelizeKeys(json))))
      .catch(response => dispatch(fetchPostsError(response)));
  };
}

export function fetchPostsRequest(profileId, opts = {}) {
  return {
    type: FETCH_POSTS_REQUEST,
    profileId,
    opts
  };
}

export function fetchPostsSuccess(result) {
  return {
    type: FETCH_POSTS_SUCCESS,
    result
  };
}

export function fetchPostsError(response) {
  return {
    type: FETCH_POSTS_ERROR,
    response
  };
}

export function fetchPost(profileId, postId, opts = {}) {
  const url = `/api/profiles/${profileId}/posts/${postId}?${queryString.stringify(opts)}`;
  return function (dispatch) {
    dispatch(fetchPostRequest(profileId, postId, opts));
    return fetch(url)
      .then(res => res.json())
      .then(json => dispatch(fetchPostSuccess(camelizeKeys(json), postId)))
      .catch(response => dispatch(fetchPostError(response, postId)));
  };
}

export function fetchPostRequest(profileId, postId, opts = {}) {
  return {
    type: FETCH_POST_REQUEST,
    profileId,
    postId,
    opts
  };
}
export function fetchPostSuccess(result, postId) {
  return {
    type: FETCH_POST_SUCCESS,
    result,
    postId
  };
}
export function fetchPostError(response, postId) {
  return {
    type: FETCH_POST_ERROR,
    postId
  };
}


export function fetchComments(profileId, postId, opts = {}) {
  const url = `/api/profiles/${profileId}/posts/${postId}/comments?${queryString.stringify(opts)}`;
  return function (dispatch) {
    dispatch(fetchCommentsRequest(profileId, postId, opts));
    return fetch(url)
      .then(res => res.json())
      .then(json => dispatch(fetchCommentsSuccess(camelizeKeys(json), postId)))
      .catch(response => { console.log(response); dispatch(fetchCommentsError(response, postId))});
  };
}

export function fetchCommentsRequest(profileId, postId, opts = {}) {
  return {
    type: FETCH_COMMENTS_REQUEST,
    profileId,
    postId,
    opts
  };
}
export function fetchCommentsSuccess(result, postId) {
  return {
    type: FETCH_COMMENTS_SUCCESS,
    result,
    postId
  };
}
export function fetchCommentsError(response, postId) {
  return {
    type: FETCH_COMMENTS_ERROR,
    postId
  };
}

export function toggleDirectionAndEmptyItems(postId) {
  return {
    type: TOGGLE_DIRECTION_AND_EMPTY_ITEMS,
    postId
  }
}

export function showModal(modalType, modalProps) {
  return {
    type: SHOW_MODAL,
    modalType,
    modalProps
  }
}

export function hideModal() {
  return {
    type: HIDE_MODAL
  }
}

export function updateWheel(scrollTop) {
  return {
    type: UPDATE_WHEEL,
    scrollTop
  }
}

export function updatePortalCategoryMore(isOpen) {
  return {
    type: PORTAL_UPDATE_CATEGORY_MORE,
    isOpen
  }
}

export function updatePortalCouponMore(isOpen) {
  return {
    type: PORTAL_UPDATE_COUPON_MORE,
    isOpen
  }
}


export function fetchCategories() {
  const url = `/api/portal/categories`;
  return function (dispatch) {
    dispatch(fetchCategoriesRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchCategoriesSuccess(result)))
      .catch(response => dispatch(fetchCategoriesError(response)));
  };
}

export function fetchCategoriesRequest() {
  return {
    type: PORTAL_FETCH_CATEGORIES_REQUEST
  }
}

export function fetchCategoriesSuccess(result) {
  return {
    type: PORTAL_FETCH_CATEGORIES_SUCCESS,
    result
  }
}

export function fetchCategoriesError(response) {
  return {
    type: PORTAL_FETCH_CATEGORIES_ERROR,
    response
  }
}

export function fetchEvents() {
  const url = `/api/portal/events`;
  return function (dispatch) {
    dispatch(fetchEventsRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchEventsSuccess(result)))
      .catch(response => dispatch(fetchEventsError(response)));
  };
}

export function fetchEventsRequest() {
  return {
    type: PORTAL_FETCH_EVENTS_REQUEST
  }
}

export function fetchEventsSuccess(result) {
  return {
    type: PORTAL_FETCH_EVENTS_SUCCESS,
    result
  }
}

export function fetchEventsError(response) {
  return {
    type: PORTAL_FETCH_EVENTS_ERROR,
    response
  }
}

export function fetchProfilesRecommendRandom() {
  const url = '/api/portal/profiles/recommends/random';
  return function (dispatch) {
    dispatch(fetchProfilesRecommendRandomRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchProfilesRecommendRandomSuccess(result)))
      .catch(response => dispatch(fetchProfilesRecommendRandomError(response)));
  };
}

export function fetchProfilesRecommendRandomRequest() {
  return {
    type: PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_REQUEST
  }
}

export function fetchProfilesRecommendRandomSuccess(result) {
  return {
    type: PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS,
    result
  }
}

export function fetchProfilesRecommendRandomError(response) {
  return {
    type: PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_ERROR,
    response
  }
}

export function fetchProfilesRise() {
  const url = '/api/portal/profiles/rise';
  return function (dispatch) {
    dispatch(fetchProfilesRiseRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchProfilesRiseSuccess(result)))
      .catch(response => dispatch(fetchProfilesRiseError(response)));
  };
}

export function fetchProfilesRiseRequest() {
  return {
    type: PORTAL_FETCH_PROFILES_RISE_REQUEST
  }
}

export function fetchProfilesRiseSuccess(result) {
  return {
    type: PORTAL_FETCH_PROFILES_RISE_SUCCESS,
    result
  }
}

export function fetchProfilesRiseError(response) {
  return {
    type: PORTAL_FETCH_PROFILES_RISE_ERROR,
    response
  }
}

export function scrollProfileRecommendRequest() {
  return {
    type: PORTAL_SCROLL_PROFILES_RISE_REQUEST
  }
}

export function scrollProfileRecommendSuccess() {
  return {
    type: PORTAL_SCROLL_PROFILES_RISE_SUCCESS
  }
}

export function fetchCouponsReceived() {
  const url = '/api/talk/received_coupons';
  return function (dispatch) {
    dispatch(fetchCouponsReceivedRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchCouponsReceivedSuccess(result)))
      .catch(response => dispatch(fetchCouponsReceivedError(response)));
  };
}

export function fetchCouponsReceivedRequest() {
  return {
    type: PORTAL_FETCH_COUPON_RECEIVED_REQUEST
  }
}

export function fetchCouponsReceivedSuccess(result) {
  return {
    type: PORTAL_FETCH_COUPON_RECEIVED_SUCCESS,
    result
  }
}

export function fetchCouponsReceivedError(response) {
  return {
    type: PORTAL_FETCH_COUPON_RECEIVED_ERROR,
    response
  }
}

export function fetchCouponRecommend(since) {
  const url = !!since ? `/api/talk/coupons?since=${since}` : `/api/talk/coupons`;
  return function (dispatch) {
    dispatch(fetchCouponRecommendRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchCouponRecommendSuccess(result)))
      .catch(response => dispatch(fetchCouponRecommendError(response)));
  };
}

export function fetchCouponRecommendRequest() {
  return {
    type: PORTAL_FETCH_COUPON_RECOMMEND_REQUEST
  }
}

export function fetchCouponRecommendSuccess(result) {
  return {
    type: PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS,
    result
  }
}

export function fetchCouponRecommendError(response) {
  return {
    type: PORTAL_FETCH_COUPON_RECOMMEND_ERROR,
    response
  }
}

export function receiveCoupon(index, couponId) {
  return {
    type: PORTAL_RECEIVE_COUPON,
    index,
    couponId
  }
}

export function addFriend(profileId, reduxNames) {
  return {
    type: PORTAL_ADD_FRIEND,
    profileId,
    reduxNames
  }
}

export function blockFriend(profileId, reduxNames) {
  return {
    type: PORTAL_BLOCK_FRIEND,
    profileId,
    reduxNames
  }
}

export function fetchMembership(profileId, addFriend = false) {
  const url = addFriend ? `/api/membership/${profileId}/add_friend` : `/api/membership/${profileId}`;
  return function (dispatch) {
    dispatch(fetchMembershipRequest());
    return fetchWithJson(url)
      .then(result => dispatch(fetchMembershipSuccess(result)))
      .catch(response => dispatch(fetchMembershipError(response)));
  };
}

export function fetchMembershipRequest() {
  return {
    type: FETCH_MEMBERSHIP_REQUEST
  }
}

export function fetchMembershipSuccess(result) {
  return {
    type: FETCH_MEMBERSHIP_SUCCESS,
    result
  }
}

export function fetchMembershipError(response) {
  return {
    type: FETCH_MEMBERSHIP_ERROR,
    response
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js